{
  "components": {
    "RefundModal": {
      "refund_the_customer": "Refund the customer",
      "refunds_take_25_days_to_appear": "Refunds take 2-5 days to appear on your customer's statement.",
      "refund_amount": "Refund amount",
      "you_can_refund_up_to_the": "You can refund up to the full payment amount of",
      "refund_all": "Refund all",
      "reason": "Reason",
      "select_a_reason": "Select a reason",
      "this_is_only_visible_to_you": "This is only visible to you and will not be shown to the\n                customer.",
      "required": "Required",
      "notes": "Notes",
      "optional": "Optional",
      "attrs": {
        "add_more_details_about_this_refund": "Add more details about this refund..."
      },
      "cancel": "Cancel",
      "refund": "Refund"
    }
  },
  "pages": {
    "RefundDetail": {
      "back_to_refunds": "Back to Refunds",
      "reject": "Reject",
      "approve": "Approve",
      "partial_refund": "Partial Refund",
      "transaction": "Transaction:",
      "refund_amount": "Refund Amount",
      "usd": "MVR",
      "of_usd": "of MVR",
      "original": "original",
      "requested_by": "Requested By",
      "merchant": "Merchant",
      "customer_information": "Customer Information",
      "name": "Name",
      "email": "Email",
      "payment_method": "Payment Method",
      "refund_reason": "Refund Reason",
      "category": "Category",
      "description": "Description",
      "additional_notes": "Additional Notes",
      "approval_workflow": "Approval Workflow",
      "refund_timeline": "Refund Timeline",
      "by": "By:"
    },
    "Refunds": {
      "total_refunds": "Total Refunds",
      "pending_refunds": "Pending Refunds",
      "completed_refunds": "Completed Refunds",
      "total_refunded": "Total Refunded",
      "attrs": {
        "search_by_refund_id_transaction_id": "Search by refund ID, transaction ID, or customer..."
      },
      "all_statuses": "All Statuses",
      "requested": "Requested",
      "pending_approval": "Pending Approval",
      "approved": "Approved",
      "processing": "Processing",
      "completed": "Completed",
      "rejected": "Rejected",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "all_reasons": "All Reasons",
      "customer_request": "Customer Request",
      "duplicate_charge": "Duplicate Charge",
      "fraudulent": "Fraudulent",
      "product_not_received": "Product Not Received",
      "product_defective": "Product Defective",
      "service_unsatisfactory": "Service Unsatisfactory",
      "billing_error": "Billing Error",
      "other": "Other",
      "customer": "Customer",
      "amount": "Amount",
      "status": "Status",
      "actions": "Actions",
      "partial": "Partial",
      "by": "by",
      "view_details": "View Details",
      "no_refunds_found": "No refunds found",
      "no_refunds_match_your_current_search": "No refunds match your current search criteria. Try adjusting your\n              filters."
    }
  }
}
